var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearchAlt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9522 15.1101L13.0557 11.2136C12.5664 11.9395 11.9405 12.5658 11.2142 13.0551L15.1107 16.9516C15.6192 17.46 16.4437 17.46 16.9522 16.9516C17.46 16.4447 17.46 15.6179 16.9522 15.1101Z",
    fill: "black",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666687 7.43758C0.666687 3.69832 3.69794 0.666748 7.40823 0.666748C11.1778 0.666748 14.1791 3.69832 14.1791 7.43758C14.1791 11.1768 11.1185 14.2084 7.40823 14.2084C3.69794 14.2084 0.666687 11.1768 0.666687 7.43758ZM3.24169 7.43758C3.24169 9.7351 5.11083 11.6042 7.40836 11.6042C9.73583 11.6042 11.575 9.73575 11.575 7.43758C11.575 5.14005 9.70588 3.27091 7.40836 3.27091C5.11083 3.27091 3.24169 5.14005 3.24169 7.43758Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchAlt);
export default __webpack_public_path__ + "static/media/search-alt.2313a269d04a81ff8e1193844588856a.svg";
export { ForwardRef as ReactComponent };